import { EmissionSource } from './emission-source.model';
import { EnergySubtype } from './energy-subtype.model';
import { EnergyType } from './energy-type.model';

export class EmissionFactor {
	energyType: EnergyType;
	energySubtype: EnergySubtype;
	value: number;
	emissionSource: EmissionSource;
}
